<!-- <p>sipment-confirmation works!</p> -->
<div class="modal-header pd-x2" >
    <h5 class="modal-title">{{ "shipment.Confirminformation" | cxTranslate }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="close(undefined)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body ">
    <div id="loader" *ngIf="enableLoader"></div>
    <div *ngIf="!enableLoader">
        <div class="col-dir col-md-12 pb-3">
            <span class="pb-2 xs-semibold-font ml-0 text-secondary" title="title">{{ "shipment.stockpilelocation" |
                cxTranslate }}</span>
            <span class="pb-2 fs-18 ff-semibold ml-0" title="location">{{shipData.stockPileLocation}}</span>
        </div>
        <div>
            <div *ngIf="section==='portside'" class="d-flex justify-content-between"><!--col-md-12 col-sm-12 mb-3 row ms-sm-auto-->
                <span class="semibold small col-md-8 col-sm-8 col-xs-8 ">{{ "shipment.Customsclearance" | cxTranslate
                    }}</span>
            <span class="pb-2 fs-18 ff-semibold ml-0 col-md-2 col-sm-2 col-xs-4" title="customClearence" *ngIf="shipData.isCustomCleared">{{'shipment.yes' | cxTranslate}}</span>
            <span class="pb-2 fs-18 ff-semibold ml-0 col-md-2 col-sm-2 col-xs-4" title="customClearence" *ngIf="!shipData.isCustomCleared">{{'shipment.no' | cxTranslate}}</span>

                <!-- <div class="btn-group btn-group-toggle col-md-4 col-sm-4 col-xs-4" data-toggle="buttons">
                 
                    <label id="yes" class="btn border1 min-height"
                        [ngClass]="shipData.isCustomCleared==true? 'active':''" (click)="checkCustomClearence('yes')">
                        <input type="radio" name="options" id="{{'optionyes'}}"
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.yes" | cxTranslate }}</label>
                    <label id="no" class="btn border1 min-height"
                        [ngClass]="shipData.isCustomCleared==false? 'active':''" (click)="checkCustomClearence('no')">
                        <input type="radio" name="options" id="{{'optionno'}}"
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.no" | cxTranslate }}</label>
                </div> -->
            </div>
            <!-- <input type="text" *ngIf="checkCustomClearenceFlag==true" class="mb-3 col-md-12 col-sm-12 form-control"> -->
            <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="shipData.isCustomCleared==true">
                <span class=" fs-18 ff-semibold ml-0" title="clearenceDate">{{converteddates?.clearenceconvertedDate |
                    date:'dd/MM/yyyy'}}</span>
            <!-- <div class="mt-3 col-md-12 col-sm-12 col-xs-12" *ngIf="shipData.isCustomCleared==true">
                <div class="inline-filter date-range-picker-form to" >
                    <fieldset>
                        <input
                        [readonly]="true"
                        name="s"
                        [footerTemplate]="footerTemplate" class="form-control bg-white small ff-normal h-40 date-width"
                        [(ngModel)]="clearenceDateTemp" 
                        id="clearenceDate"
                        placeholder="DD/MM/YYYY"
                    />
                    </fieldset>
                </div>
            </div> -->
            </div>
            <div class="hr"></div>
            <div class="mb-3 mt-3 d-flex justify-content-between"><!--col-md-12 col-sm-12 mb-3 row ms-sm-auto-->
                <span class="semibold small col-md-10 col-sm-10 col-xs-8 ">{{ "shipment.Dischargecompleted" | cxTranslate
                    }}</span>
                <span class="pb-2 fs-18 ff-semibold ml-0 col-md-2 col-sm-2 col-xs-4" title="discharge" *ngIf="shipData.checkDischargeCompletedFlag">{{'shipment.yes' | cxTranslate}}</span>
                <span class="pb-2 fs-18 ff-semibold ml-0 col-md-2 col-sm-2 col-xs-4" title="discharge" *ngIf="!shipData.checkDischargeCompletedFlag">{{'shipment.no' | cxTranslate}}</span>

                <!-- <div class="btn-group btn-group-toggle col-md-4 col-sm-4 col-xs-4" data-toggle="buttons">
                    <label id="yes" class="btn border1 min-height "
                        [ngClass]="shipData.isDischarged==true? ' disabled-highlight ':''" (click)="checkDischargeCompleted('yes')">
                        <input type="radio" name="options" id="{{'optionyes'}}"
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.yes" | cxTranslate }}</label>
                    <label id="no" class="btn border1 min-height"
                        [ngClass]="shipData.isDischarged==false && checkDischargeCompletedFlag==false? 'active':'disabled'" (click)="checkDischargeCompleted('no')">
                        <input type="radio" name="options" id="{{'optionno'}}"
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.no" | cxTranslate }}</label>
                </div> -->
            </div>
        </div>
        <hr>
        <div class="col-dir col-md-12 pb-3">
            <span class=" pb-2 xs-semibold-font ml-0 text-secondary" title="eta">{{ "shipment.ETA" | cxTranslate
                }}</span>
            <span class=" fs-18 ff-semibold ml-0" title="etaDate">{{converteddates.etaconvertedDate |
                date:'dd/MM/yyyy'}}</span>
            <span class=" fs-14 ml-0 text-secondary" title="etaTime">{{shipData.etaTime?shipData.etaTime:''}}</span>

        </div>
        <div class="col-dir col-md-12 pb-3">
            <span class="pb-2 xs-semibold-font ml-0 text-secondary" title="etb">{{ "shipment.ETB" | cxTranslate
                }}</span>
            <span class=" fs-18 ff-semibold ml-0" title="etbDate">{{converteddates.etbconvertedDate |
                date:'dd/MM/yyyy'}}</span>
            <span class=" fs-14  ml-0 text-secondary" title="etbTime">{{shipData.etbTime?shipData.etbTime:''}}</span>
        </div>
        <div class="col-dir col-md-12 pb-3">
            <span class="pb-2 xs-semibold-font ml-0 text-secondary" title="etcd">{{ "shipment.ETSD" | cxTranslate
                }}</span>
            <span class=" fs-18 ff-semibold ml-0" title="etcdDate">{{converteddates.etsdconvertedDate |
                date:'dd/MM/yyyy'}}</span>
            <span class=" fs-14  ml-0 text-secondary" title="etcdTime">{{shipData.etsdTime?shipData.etsdTime:''}}</span>
        </div>
        <div class="col-dir col-md-12 pb-3">
            <span class="pb-2 xs-semibold-font ml-0 text-secondary" title="etsd">{{ "shipment.ETCD" | cxTranslate
                }}</span>
            <span class="fs-18 ff-semibold ml-0" title="etsdDate">{{converteddates.etcdconvertedDate |
                date:'dd/MM/yyyy'}}</span>
            <span class=" fs-14  ml-0 text-secondary" title="etsdTime">{{shipData.etcdTime?shipData.etcdTime:''}}</span>
        </div>
    </div>
</div>
<div class="modal-footer " >
    <div class="col-md-12 col-sm-12">
        <button class="btn btn-block btn-lg  btn-primary" type="submit" (click)="save()">{{ "shipment.confirm" | cxTranslate }}</button> 
        <div class="d-flex justify-content-between mt-2">
            <button class="btn btn-lg btn-light button" type="button" (click)="backToEdit()">{{ "shipment.back" | cxTranslate }}</button>
            <button class="btn btn-lg btn-light button" type="button" (click)="ActiveModal.dismiss('close click');"
                data-dismiss="modal">{{ "shipment.close" | cxTranslate }}</button>
        </div>
     </div>
</div>
